import { ConfigService } from "../../services/config.service";
import { Component, OnInit, Input, EventEmitter, NgZone } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormGroup, FormBuilder } from '@angular/forms';
import { LanguagesService } from 'src/app/services/language.service';
import { ControlMessages } from 'src/app/components/control-messages/controlMessages.component';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
    selector: 'moia-captcha',
    template: `<div class="g-recaptcha" id="captcha_element_place" *ngIf="loaderReady" data-callback="resolved"></div>
    <div *ngIf="!isFormValidation && isSubmitted && !captcha" class="invalid-feedback">
      <div class="red-color">חובה לאמת שאתם לא רובוט</div>
    </div>
    <control-messages *ngIf="isFormValidation"  [control]="f.captchaValue" [isShow]="isShowMessage" ></control-messages>
    <br>`,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class MoiaCaptchaComponent implements OnInit {
    private siteKey: string;
    private loading = new EventEmitter<string>();
    public loaderReady = false;
    captcha: string = undefined;
    private _isSubmitted: boolean;
    private _isFormValidation: boolean = false;
    isShowMessage: boolean = false;
    @Input() 
    set isFormValidation(val: boolean)
    {
        this._isFormValidation = val;
    }
    get isFormValidation() {
        return this._isFormValidation;
    }
    @Input()
    set isSubmitted(val: boolean) {
        this._isSubmitted = val;
        if (this._isSubmitted && this._isFormValidation) {
            this.isShowMessage = (this.captchaForm.controls.captchaValue.value != "valid");
            if (this.isShowMessage)
                this.captchaForm.controls.captchaValue.setValue('notValid');
        }
    }
    captchaForm: FormGroup;

    constructor(private _lang_service: LanguagesService,
        private zone: NgZone,
        private formBuilder: FormBuilder,
        configService: ConfigService) {
        this.siteKey = configService.getConfiguration().captchaV3SiteKey;
    }

    get f() {
        return this.captchaForm.controls;
    }

    get isSubmitted(): boolean {

        return this._isSubmitted;
    }

    ngOnInit() {
        window['resolved'] = this.resolved.bind(this);

        this.loading.subscribe(v => {
            setTimeout(() => {
                this.zone.run(() => this.loaderReady = true);
                this.captcha = undefined;
            }, 0);
        });

        this.AddCaptchaElement();
        this._lang_service.getLanguage().subscribe((flag) => {
            this.ChangeCaptchaLanguage(this._lang_service.activeLanguage);
        });

        if (this._isFormValidation)
          this.captchaForm = this.formBuilder.group({
              'captchaValue': ['', [ValidationService.captchaValidator]],
          });
    }

    AddCaptchaElement() {
        const script = document.createElement('script');
        script.type = "text/javascript";
        script.text = `var onloadCallback = function() {
      grecaptcha.render('captcha_element_place', {
        'sitekey' : '` + this.siteKey + `'` +
        `});
    };`;
        document.head.appendChild(script);
    }

    AddCaptcha(lang = 'he') {
        const script = Object.assign(document.createElement('script'), { id: "captchaScript" }) as HTMLScriptElement;
        script.innerHTML = '';
        script.src = `https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=` + lang;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    ChangeCaptchaLanguage(lang = 'he') {
        var findScr = document.scripts.namedItem('captchaScript');
        if (findScr)
            findScr.parentNode.removeChild(findScr);
        this.loaderReady = true;
        this.AddCaptcha(lang);
        this.loaderReady = false;
        this.loading.emit();
    }

    reset() {
        this.captcha = undefined;
        grecaptcha.reset();
        ControlMessages.clearForm(this.captchaForm);
        this.isShowMessage = false;
    }

    GetResponse() {
        if (!this.captcha)
            this.captcha = undefined;
        return this.captcha;
    }

    resolved() {
        setTimeout(() => {
            this.zone.run(() => this.captcha = grecaptcha.getResponse())
        }, 0);

        if (this._isFormValidation)
          this.captchaForm.controls.captchaValue.setValue('valid');
    }
}
